import Tooltip from "@mui/material/Tooltip";
import React from "react";
import IconButton from "@mui/material/IconButton";
import {FiZoomIn, FiZoomOut} from "react-icons/fi";
import PropTypes from "prop-types";
import {
    ZoomIn,
    ZoomOut,
} from "lucide-react";
import {
    Box,
    Typography,
} from "@mui/material";

const Scale = ({ scale, setScale, t }) => {

    const isMinZoom = scale <= 0.1;
    const isMaxZoom = scale >= 4.0;

    const zoomOutClass = isMinZoom ? 'disabled' : 'clickable';
    const zoomInClass = isMaxZoom ? 'disabled' : 'clickable';

    const zoomOut = () => {
        if (!isMinZoom) setScale(scale - 0.1);
    };

    const zoomIn = () => {
        if (!isMaxZoom) setScale(scale + 0.1);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                backgroundColor: 'rgb(75 78 83 / 70%)',
                borderRadius: 2,
                paddingLeft: "8px",
                paddingRight: "8px",
                paddingTop: "4px",
                paddingBottom: "4px"
            }}
        >
                <Tooltip title={t('zoom_out')}>
                    <IconButton aria-label="Zoom out" className={`${zoomOutClass}`} id="basic-button"
                                onClick={zoomOut}>
                        <ZoomOut size={16} />
                    </IconButton>
                </Tooltip>
            <Typography style={{fontSize: '14px', color: 'white'}}>{(scale * 100).toFixed()}%</Typography>
                <Tooltip title={t('zoom_in')}>
                    <IconButton aria-label="Zoom in" className={`${zoomInClass}`} id="basic-button"
                                onClick={zoomIn}>
                        <ZoomIn size={16} />
                    </IconButton>
                </Tooltip>
        </Box>

    );

}

Scale.propTypes = {
    scale: PropTypes.number,
    setScale: PropTypes.func,
    t: PropTypes.func,

};
export default Scale;